/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const Avatar = styled.div({
  alignItems: 'center',
  display: 'flex',
  marginRight: token('space.100'),
});

export const Item = styled.div({
  alignItems: 'center',
  display: 'flex',
  margin: `${token('space.100')} 0`,
});

export const Summary = styled.div({
  flex: 1,
  minWidth: 0,
});
